import { SerializedError } from '@reduxjs/toolkit';

export type TypeResponse<T> = {
  data: T;
  error?: SerializedError | null;
  dataUpdatedAt?: number;
  isLoading: boolean;
};

export enum ExportType {
  Default = 'Default',
  Full = 'Full',
}

export interface EnumValue {
  readonly value: string;
  readonly text: string;
  readonly icon: string;
  readonly color: string;
  readonly parameterColor: string | null;
  readonly rawValue: string | null;
}

export type HistoryParameter = {
  readonly id: string;
  readonly name: string;
  readonly enumValues: EnumValue[];
  readonly unit: string;
  readonly decimals: number;
  readonly color: string | null;
};

export type SelectedDevicesType = Record<string, Map<string, string>>;

export type HistoryParamsBody = {
  deviceIds: string[];
  parameterIds: string[];
};

export interface HistoryDevice {
  readonly deviceId: string;
  readonly deviceName: string;
}

export interface HistoryObject {
  readonly devices: ReadonlyArray<HistoryDevice>;
  readonly historyId: string;
  readonly parameters: ReadonlyArray<HistoryParameter>;
  readonly dateFrom?: Date;
  readonly dateTo?: Date;
}

export interface HistoryChartData {
  dataPoints: Record<string, string | number>[];
  isDevicesChart?: boolean;
}

export type ExportHistoryBody = {
  deviceId: string;
  parameterIds: string[];
  dateFrom: string;
  dateTo: string;
  exportType: ExportType;
};

export type HistoryParameterGroupItem = {
  deviceId: string;
  decimals: number;
  parameterId: string;
  parameterName: string;
  parameterUnit: string;
  parameterUnitText: string;
  accessLevel: string;
  presentation: string;
  enumValues: EnumValue[];
  scaleValue: number;
  stepValue: number;
  prio?: number;
  category: string;
};

export type HistoryParameterGroup = {
  id: string;
  name: string;
  parameters: HistoryParameterGroupItem[];
};

export type HistoryParametersGroupResponse = {
  parameters: HistoryParameterGroupItem[];
  groupedParameters: HistoryParameterGroup[];
};
